import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import getPrettyError from '../../utils/getPrettyError';
import request from '../../utils/request';
import usePublicLink from '../../apps/PublicLink/usePublicLink';
var DEFAULT_CHECK_INTERVAL = 30 * 60 * 1000;
/**@type {import('./types').LicensingProviderStatus} */

var DEFAULT_LICENSING = {
  initializing: true,
  error: '',
  hasLicense: false,
  hasTrial: false,
  allowTrial: false,
  trialExpired: false,
  remainingDays: 0,
  startingTrial: false,
  retrying: false
};
/**
 * @returns {import('./types').LicensingProviderStatus}
 */

var useLicensing = function useLicensing(checkTrial) {
  var ref = React.useRef(true);

  var _React$useState = React.useState(DEFAULT_LICENSING),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _usePublicLink = usePublicLink(),
      publicId = _usePublicLink.publicId;

  React.useEffect(function () {
    if (publicId) {
      setState(function (s) {
        return _objectSpread({}, s, {
          hasLicense: true,
          initializing: false
        });
      });
    }
  }, [publicId]);

  var requestLicensing =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (checkTrial) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", request({
                url: '/api/microservices/v1/licensing'
              }).then(function () {
                if (!ref.current) return;
                setState(_objectSpread({}, state, {
                  hasLicense: true,
                  error: '',
                  initializing: false
                }));
              }).catch(function () {
                if (!ref.current) return;
                setState(_objectSpread({}, state, {
                  hasLicense: false,
                  error: '',
                  initializing: false
                }));
              }));

            case 2:
              return _context.abrupt("return", request({
                url: '/api/licensing',
                useMicroserviceBackend: true
              }).then(function (licensingInfo) {
                if (!ref.current) return;
                var HasLicense = licensingInfo.HasLicense,
                    HasTrial = licensingInfo.HasTrial,
                    Error = licensingInfo.Error;
                var AllowTrial = licensingInfo.AllowTrial,
                    TrialExpired = licensingInfo.TrialExpired,
                    RemainingDays = licensingInfo.RemainingDays;
                setState({
                  initializing: false,
                  hasLicense: HasLicense,
                  hasTrial: HasTrial,
                  error: Error || '',
                  allowTrial: AllowTrial,
                  trialExpired: TrialExpired,
                  remainingDays: RemainingDays
                });
              }).catch(function (error) {
                if (!ref.current) return;
                setState(_objectSpread({}, state, {
                  initializing: false,
                  error: getPrettyError(error),
                  hasLicense: false,
                  hasTrial: false
                }));
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestLicensing() {
      return _ref.apply(this, arguments);
    };
  }();

  var startTrial = function startTrial(onTrialStarting) {
    setState(_objectSpread({}, state, {
      startingTrial: true,
      error: ''
    }));
    return request({
      method: 'POST',
      url: '/api/licensing/request',
      useMicroserviceBackend: true
    }).then(function (licensingInfo) {
      var HasTrial = licensingInfo.HasTrial,
          Error = licensingInfo.Error,
          AllowTrial = licensingInfo.AllowTrial,
          RemainingDays = licensingInfo.RemainingDays;
      setState(_objectSpread({}, state, {
        allowTrial: AllowTrial,
        remainingDays: RemainingDays,
        startingTrial: false,
        hasTrial: HasTrial,
        error: Error
      }));
      onTrialStarting && onTrialStarting();
    }).catch(function (error) {
      setState(_objectSpread({}, state, {
        startingTrial: false,
        hasTrial: false,
        error: getPrettyError(error)
      }));
    });
  };

  var refreshTimer = null;
  React.useEffect(function () {
    if (publicId) return;

    var addTimeout = function addTimeout() {
      clearTimeout(refreshTimer);
      if (!ref.current) return;
      refreshTimer = setTimeout(function () {
        requestLicensing().then(addTimeout);
      }, DEFAULT_CHECK_INTERVAL);
    };

    requestLicensing().then(addTimeout);
    return function () {
      clearTimeout(refreshTimer);
      ref.current = false;
    };
  }, [publicId]);
  return _objectSpread({}, state, {
    actions: {
      startTrial: startTrial,
      retry: requestLicensing
    }
  });
};

export default useLicensing;